
<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/social/fondo-social.jpg" style="background-image: url('assets/img/social/fondo-social.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Componente Social - Proyecto IOARR
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-rosario-2.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>COMPONENTE SOCIAL</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">La Gerencia del Centro Histórico del Cusco
                  tiene la misión de ser promotor del desarrollo integral concertado y sostenible en su ámbito en este
                  caso en la IOARR: “ADQUISICIÓN DE SISTEMA DE INFORMACIÓN; EN EL (LA) OPTIMIZACIÓN DEL SISTEMA DE
                  INFORMACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO, DISTRITO CUSCO,
                  PROVINCIA DE CUSCO, DEPARTAMENTO CUSCO”. <br> Se tiene al componente social, el cual desarrolla dos partidas
                  importantes, la partidad de la sistematización del patrimonio cultural inmaterial y la partida de difusión del proceso
                  de catalogación y sistematización del proyecto.
                  </p>
              </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap mt-sm-10" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/social/coordinadora.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">EC. KATERIN LOIAZA QUISPE</h3>
                    <h6 class="designation mb-20" style="text-align: center;">COORDINADORA COMPONENTE SOCIAL</h6>
                </div>
            </div>
          </div>
      </div>
  </div>
</section>

<section id="landing-service-area-wrapper" class="pt-68 pt-md-26 pt-sm-20 pb-114 pb-md-76 pb-sm-56" style="background-image: url('/assets/img/social/fondo-torito2.png'); ">
  <div class="container">

    <div class="row">
      <div class="col-lg-12 text-center" style="margin-bottom:-60px;">
        <div class="section-title-wrap">
          <h3 style="color:white">Partidas del Componente Social</h3>
        </div>
      </div>
      <!-- Single Service Item #1 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>Sistematización del Patrimonio Inmaterial</h3>
            <p class="m-0">
            El patrimonio cultural inmaterial o “patrimonio vivo” se refiere a las prácticas, expresiones, saberes o técnicas transmitidas por las comunidades,
            de generación en generación. Como es sabido hace ya buen tiempo, el patrimonio cultural no se limita solo a monumentos u objetos, sino que comprende
            también las tradiciones o expresiones vivas que se heredan de nuestros antepasados y que se transmiten a nuestros descendientes.
            Este va a proporcionar a las comunidades un sentimiento de identidad y de continuidad el cual favorece la creatividad y el bienestar social,
            contribuye a la gestión del entorno natural y social y genera ingresos económicos.
            <br><br>El Centro histórico del Cusco, dentro de su ámbito de espacio alberga muchas manifestaciones de carácter inmaterial, costumbres, festividades que
            involucran a su población, dichas manifestaciones con el paso del tiempo y sucesos externos, se van perdiendo cada vez más; consientes de este problema
            y teniendo en cuenta la importancia de la salvaguarda de este patrimonio la Gerencia de Centro Histórico del Cusco ejecutó la IOARR
            dentro del componente Patrimonio Cultural Inmaterial, se realizó el registro de más de 90 expresiones culturales con
            la participación de diferentes actores sociales.
            </p>
          </div>
        </div>
      </div>
      <!-- Single Service Item #2 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>Difusión, sensibilización y socialización  </h3>
            <p class="m-0">
              La partida de difusión, sensibilización y socialización del proceso de catalogación y sistematización del proyecto, tiene como
              actividades que se llevan de manera continua en el proyecto, la edición audiovisual de las entrevistas realizadas al patrominio inmaterial del Cusco
              publicándose en las plataformas digitales de <a href="https://www.facebook.com/gerenciacentrohistoricocusco" target="_blank"> Facebook</a> e <a href="https://www.instagram.com/gerenciadecentrohistorico/" target="_blank">Instagram</a>, como tambien en
              nuestro canal de <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" target="_blank">Youtube</a> a travéz de nuestro programa <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" target="_blank">"HATUN QOSQO"</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="custom-search-page-area mt-118 mt-md-80 mt-sm-60 mb-120 mb-md-80 mb-sm-60" style="background-image: url('/assets/img/fondo-componentes.png'); background-size: cover;
background-position: center;">
  <div class="container-fluid">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-5 m-auto text-center">
        <div class="section-title-wrap layout--2">
          <h2>Productos Finales</h2>
          <p class="mb-0">
            Dentro del componente Social, se realizó la entrega de 3 productos puestos a disposición del público en general, a través de nuestros canales de difusión.
          </p>
        </div>
      </div>
      <!-- End Section title -->
    </div>
    <div class="row no-gutters">
      <!-- Start Single Custom Search Item #01 -->
      <div class="col-lg-4 col-sm-6 text-center">
        <div class="single-custom-search-item">
          <i class="fa fa-file"></i>
          <h2 style="color:white;">PATRIMONIO INMATERIAL</h2>
          <p>
            Teniendo en cuenta la importancia de salvaguardar el patrimonio inmaterial, la Gerencia de Centro Histórico ejecutó la IOARR:
            “ADQUISICIÓN DE SISTEMA DE INFORMACIÓN; EN EL (LA) OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES
            DEL CENTRO HISTÓRICO, DISTRITO, PROVINCIA Y DEPARTAMENTO DE CUSCO”. En el cual se realizó el registro de más de 71 expresiones culturales con la participación de diferentes
            actores sociales, teniendo como resultado entrevistas
            a profundidad que nos permiten conocer las actividades realizadas por ellos, mostrandolas en <a href="http://catalogacion.cusco.gob.pe/inmaterial">"INMATERIAL"</a>.
          </p>
        </div>
      </div>
      <!-- End Single Custom Search Item #01 --><!-- Start Single Custom Search Item #02 -->
      <div class="col-lg-4 col-sm-6 text-center">
        <div class="single-custom-search-item">
          <i class="fa fa-film"></i>
          <h2 style="color:white;">"HATUN QOSQO"</h2>
          <p>
            De la misma forma, presentamos el programa “HATUN QOSQO” en el cual se emiten vídeos documentales que recogen
            y exponen muestras del patrimonio material e inmaterial que se alberga en el Centro Histórico del Cusco.
            Programa realizado a partir de las entrevistas realidas en la catalogación del patrimonio inmaterial de nuestra
            ciudad, permitiendo a través de este programa la difusión de nuestra cultura e historia, revalorando nuestras actividades
            ansestrales pasadas de generación en generación.
          </p>
          <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" target="_blank" > <button class="btn btn-brand" >Ver programa</button></a>
        </div>
      </div>
      <!-- End Single Custom Search Item #02 --><!-- Start Single Custom Search Item #03 -->
      <div class="col-lg-4 col-sm-6 text-center">
        <div class="single-custom-search-item">
          <i class="fa fa-book"></i>
          <h2 style="color:white;">“EL CENTRO DEL CUSCO”</h2>
          <p>
            LA MUNICIPALIDAD DEL CUSCO A TRAVÉS DE LA GERENCIA DE CENTRO HISTÓRICO tiene el agrado de presentar
            el libro: “EL CENTRO DEL CUSCO”, Morada de historia de cultura viva”, publicación que recopila y
            muestra a manera de pinceladas la monumentalidad de inmuebles y ambientes urbanos que son parte de nuestro
            patrimonio cultural tangible, nos presenta también un recorrido por la historia y la evolución urbana de nuestro
            Cusco, así como que el QUE HACER de maestros del arte, apasionados por el Cusco que difunden oficios tradicionales,
            oralidad, gastronomía, mitos y otras expresiones culturales del patrimonio inmaterial.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="team-member-area pt-118 pt-md-80 pt-sm-60" style="background-image: url('/assets/img/fondo-equipo.png'); background-size: cover; background-position: center;">
  <div class="container" >
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-6 m-auto text-center">
        <div class="section-title-wrap layout--2">
          <h2>Equipo de trabajo</h2>
          <p class="mb-0">
            El componente social estuvo conformado por los siguientes profesionales.
          </p>
        </div>
      </div>
      <!-- End Section title -->
    </div>
  </div>
</section>
<section class="team-member-area">
  <div class="team-content-wrapper d-flex flex-wrap mtm-30">
    <!-- Start Single Team Member -->

    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/social/mariela.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Antrop. MARIELA VALER RAMIREZ</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Coordinadora Patrimonio Inmaterial</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/social/johan.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Hist. JOHAN STEVE PEREZ TUPAYACHI</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Historiador</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/social/luis.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Cs. de la Comunicación LUIS GIUSSEPPE BEJAR CHACON</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Editor Audiovisual</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/social/david.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Diseñador Gráfico DAVID MAURICIO MIRANDA AGUILAR</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Diseñador Gráfico</h5>
        </figcaption>
      </figure>
    </div>
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/social/sra-silvia.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Lic. Cs. de la Comunicación SILVIA MARÍA BAÑOS ESTRADA</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Comunicadora</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member -->
  </div>
</section>

<section class="team-member-area pt-80 pt-md-80 pt-sm-60 pb-60" style="background-image: url('/assets/img/fondo-rosario-2.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-md-5 col-lg-12">
        <h2 style="font-size:24px;color:#FDC657;">Profesionales del Componente Social:</h2>
        <div class="port-details-con-inner">
          <div class="single-post-details__footer m-0">
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Coordinadora Comp. Social:</h5>
              </div>
              <div class="footer-item-right">
                <span>Ec. ZENAIDA SUNE PUMACAYO </span>
              </div>
            </div>

            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asist. Patrimonio Inmaterial:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Antrop. MIJAIL OCTAVIO CONCHA SUCÑIER </span>
              </div>
            </div>

            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asist. Patrimonio Inmaterial:</h5>
              </div>
              <div class="footer-item-right">
                <span>Antrop. CECILIA CANAL RECHARTE </span>
              </div>
            </div>

            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asist. Patrimonio Inmaterial:</h5>
              </div>
              <div class="footer-item-right">
                <span>Antrop. NATALY ALMANZA ASCUE </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asist. Patrimonio Inmaterial:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Hist. JHON DANTE TTITO VALDEZ </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Asist. Patrimonio Inmaterial:</h5>
              </div>
              <div class="footer-item-right">
                <span>RICARDO RECHARTE HILARES </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Comunicador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Cs. de la Comunicación LUIS ALFREDO SILVA DE ECHAVE </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Comunicador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Lic. Cs. de la Comunicación RAMIRO MOREYRA PORTILLA </span>
              </div>
            </div>

            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Comunicador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Cs. de la Comunicación JOEL EDUARDO SALAS VILLENA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Comunicador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Lic. Cs. de la Comunicación GENY JUNIOR VILA GARCIA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Editor Audio visual:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Cs. de la Comunicación ANDREA VALDIVIA MANZANARES </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Diseñadora Gráfica:</h5>
              </div>
              <div class="footer-item-right">
                <span>Artísta Plástica ANGIE VALERIE VELASCO GONZALES </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/social/inmaterial01.jpg" class="btn-img-gallery">
                      <img src="assets/img/social/inmaterial01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial02.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/social/inmaterial03.jpg" class="btn-img-gallery">
                      <img src="assets/img/social/inmaterial03.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial04.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial05.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial05.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial06.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial06.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial07.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial07.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial08.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial08.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial09.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial09.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial10.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial10.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial11.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial11.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial12.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial12.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial13.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial13.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial14.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial14.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial15.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial15.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/social/inmaterial16.jpg" class="btn-img-gallery">
                    <img src="assets/img/social/inmaterial16.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>
